import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { Role } from '../../models/permissions/role.model';
@Injectable({
  providedIn: 'root'
})
export class RolesService {

  constructor(private httpClient: HttpClient) {
  }

  getList(): Observable<Role[]> {
    return this.httpClient.get<Role[]>(environment.API_URL + '/api/admin/roles/getList').pipe(
      map(data => data));
  }

  update(role: Role): Observable<Boolean> {
    return this.httpClient.post<Boolean>(environment.API_URL + '/api/admin/roles/update', role).pipe(
      map(data => data));
  }

  create(role: Role): Observable<Boolean> {
    return this.httpClient.post<Boolean>(environment.API_URL + '/api/admin/roles/create', role).pipe(
      map(data => data));
  }

  delete(roleId: number): Observable<Boolean> {
    return this.httpClient.post<Boolean>(environment.API_URL + '/api/admin/roles/delete/', roleId).pipe(
      map(data => data));
  }
}
